import { SsThread } from 'src/js/dom/thread.js';

export default async function () {
  const thread = new SsThread( document.getElementById( 'ss-thread' ) );
  thread.addItems( '.thread-item' );
  await thread.activateItems();
  return Promise.resolve();
}
